import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { APP_NAME, WEBSITE_LINK } from 'constants/config';

export default function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href={WEBSITE_LINK}>
                {APP_NAME}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}